import React from 'react';
import './styles.css';

interface ToggleSwitchProps {
  isMonthly: boolean;
  onToggle: () => void;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ isMonthly, onToggle }) => {
  return (
    <div className="pricing-toggle">
      <span className={`toggle-option ${isMonthly ? 'active' : ''}`}>Monthly</span>
      <label className="toggle-switch-container">
        <input
          type="checkbox"
          checked={!isMonthly}
          onChange={onToggle}
          className="toggle-input"
          aria-label="Toggle between monthly and yearly pricing"
        />
        <span className="toggle-switch"></span>
      </label>
      <span className={`toggle-option ${!isMonthly ? 'active' : ''}`}>Yearly</span>
    </div>
  );
};

export default ToggleSwitch;
